module.exports = __tmimport("~endpoint:{controller: \'event\', action: \'show\', event_id: \':id\'}");